'use client';
import SubscriptionCard from '@/components/SubscriptionCard';
import { fetchSubscriptions } from '@/services/supabase-service';
import { Subscription } from '@/types/type';
import { useEffect, useState } from 'react';
import { FlatList } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

export default function Feed() {
  const [subsList, setSubscriptions] = useState<Subscription[]>([]);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const PAGE_SIZE = 10;

  const [refreshing, setRefreshing] = useState(false);

  const onRefresh = async () => {
    setRefreshing(true);
    setLoading(true);

    const [subscriptions] = await Promise.all([fetchSubscriptions(PAGE_SIZE, subsList.length)]);

    setSubscriptions((prev) => [...prev, ...subscriptions]);
    setHasMore(subscriptions.length > 0);

    setRefreshing(false);
    setLoading(false);
  };

  useEffect(() => {
    onRefresh();
  }, []);

  return (
    <SafeAreaView className="h-full w-full">
      <FlatList
        //estimatedItemSize={10}
        data={subsList}
        renderItem={({ item }) => <SubscriptionCard key={item.id} subscription={item} />}
        keyExtractor={(item) => item.id?.toString() || String(Math.random())}
        onEndReached={onRefresh}
        onEndReachedThreshold={0}
        refreshing={refreshing}
        onRefresh={() => {
          setSubscriptions([]);
          onRefresh();
        }}
      />
    </SafeAreaView>
  );
}
